<template>
  <v-row>
    <v-col cols="12">
      <h5 class="-font">{{ text }}</h5>
    </v-col>
    <v-col cols="12">
      <v-radio-group v-model="model" :rules="[requiredRule]" hide-details="auto">
        <v-radio
          v-for="option in options"
          :key="option.value"
          :label="option.label"
          :value="option.value"
          class="secondary-font font-weight-bold"
        />
      </v-radio-group>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    requiredRule(value) {
      return !!value || 'Selecione uma opção.'
    }
  }
}
</script>

<style scoped>
.v-input >>> label {
  font-size: 14px !important;
  color: black !important;
}
</style>
